import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { VariantType } from 'notistack';

export type Notification = {
  type: VariantType | undefined;
  id: string;
  variant: VariantType;
  message: string;
};

type NotificationState = {
  notifications: Notification[];
};

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    createNotification(state, action: PayloadAction<Partial<Notification>>) {
      const payload = action.payload;

      if (!payload.id) {
        payload.id = `${Date.now()}`;
      }

      state.notifications = [action.payload as Notification];
    },
  },
});

export const notificationSelector = (state: RootState) => state.notification;

export const { createNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
